import { render } from "./admin-deras-reviews.vue?vue&type=template&id=fd36fd4a&scoped=true"
import script from "./admin-deras-reviews.vue?vue&type=script&lang=js"
export * from "./admin-deras-reviews.vue?vue&type=script&lang=js"

import "./admin-deras-reviews.vue?vue&type=style&index=0&id=fd36fd4a&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd36fd4a"]])

export default __exports__